import React, { useState, useEffect } from "react";
import useRequireAuth from "../../utils/useRequireAuth";
import { deleteContactPersonDataAsync, saveContactPersonDataAsync } from "../../utils/customer/contactPersonsSlice";

import { useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useFetchCustomerDesignationQuery } from "../../utils/customer/customerSelect";
import useClickOutside from "../../hooks/Screen/useClickOutside";
import useCustomFormValidation from "../../hooks/ErrorHandling/useCustomFormValidation";
import { pushAlert } from "../../utils/alertSlice";
import { useUpdateCustomerContactTableDataMutation } from "../../utils/customer/customerTaskTable";
import { ReactComponent as Profile } from "../../assets/images/icons/Profile.svg";
import { ReactComponent as GmailIcon } from "../../assets/images/icons/GmailIcon.svg";
import { ReactComponent as Call } from "../../assets/images/icons/Call.svg";
import CopyIconComponent from "../UniversalComponents/CopyIconComponent";
import { getUserId } from "../../utils/utilityFunctions/localServices";
import { ReactComponent as personContact } from "../../assets/images/icons/personContact.svg";

const validationRules = {
  name: {
    required: true,
    errorMessage: "Name is required.",
  },
  contact_no: [
    {
      required: true,
      errorMessage: "Phone Number is required.",
    },
    {
      number: true,
      errorMessage: "Phone Number should contain only digits.",
    },
    {
      maxDigits: 15,
      errorMessage: "Must be between 1 to 15 digits.",
    },
  ],
  contact_email: [
    {
      required: true,
      errorMessage: "Email is required.",
    },
    {
      email: true,
      errorMessage: "Provide valid email",
    },
  ],
};

const CustomerContactPersonModel = ({
  onClose,
  isEditMode,
  setIsEditMode,
  addCustomerId,
  setAddCustomerId,
  customerContactPersonData,
  onSave,
  handleDelete,
  isAddMode,
  setIsAddMode,
  EmptyMessage,
  handleCancel,
}) => {
  const [customer, setCustomer] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [editData, setEditData] = useState(null);
  const [customerTablePagination, setCustomerTablePagination] = useState(null);
  const [initialFilter, setInitialFilter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [itemHover, setItemHover] = useState(null);

  const { token } = useRequireAuth();
  const { id } = useParams();
  const customerId = parseInt(id);
  const dispatch = useDispatch();
  const companyLocalData = localStorage.getItem("company_data");
  const parsedCompanyData = JSON.parse(companyLocalData);
  const [isValidEmail, setIsValidEmail] = useState(true);

  const closeModalOutside = useClickOutside(() => {
    onClose();
  });
  const [formErrors, setFormErrors] = useState({
    name: "",
    contact_no: "",
    contact_email: "",
  });
  const [formData, setFormData] = useState({
    id: "",
    name: "",
    contact_no: "",
    contact_email: "",
  });

  const { values, errors, touched, handleChange, handleBlur, validateField, isFormValid } = useCustomFormValidation(
    formData,
    validationRules
  );

  const handleFieldChange = (e) => {
    handleChange(e);
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    const requiredFields = ["name", "contact_no", "contact_email"];
    const errors = {};
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        errors[field] = "Cannot be left blank.";
      }
    });

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const UserId = getUserId();

  const handleSave = async (event) => {
    event.preventDefault();
    const formValid = isFormValid();

    if (!formValid) {
      return;
    }
    const contactPerson = {
      recordType: "contact",
      id: formData?.id ? formData?.id : "",
      customer_id: addCustomerId ? addCustomerId : customerId,
      user_id: UserId,
      name: event.target.name.value,
      contact_no: event.target.contact_no.value,
      contact_email: event.target.contact_email.value,
    };
    onSave(contactPerson);
  };

  useEffect(() => {
    const handleEscKeyPress = (event) => {
      if (event.key === "Escape") {
        onClose(); // Call the onClose function when Escape is pressed
      }
    };

    // Add event listener for keydown event
    document.addEventListener("keydown", handleEscKeyPress);

    // Cleanup the event listener when component unmounts
    return () => {
      document.removeEventListener("keydown", handleEscKeyPress);
    };
  }, [onClose]);

  const handleEdit = (id, rowData) => {
    setIsEditMode(true);
    setEditData(rowData);
    setFormData({
      id: rowData?.id,
      name: rowData?.name,
      contact_email: rowData?.contact_email,
      contact_no: rowData?.contact_no,
    });
  };

  useEffect(() => {
    if (isAddMode) {
      setFormData({
        id: "",
        name: "",
        contact_email: "",
        contact_no: "",
      });
    }
  }, [isAddMode]);

  const [updateCustomerContactTableData, { CustomerDropLoad, CustomerDroperror }] =
    useUpdateCustomerContactTableDataMutation();

  const customerTableFieldUpdate = async (event) => {
    const name = event?.target?.name?.value;
    const email = event?.target?.contact_email?.value;
    const number = event?.target?.contact_no?.value;

    try {
      event.preventDefault();

      const updateData = [
        {
          field_name: "name",
          value: name,
        },
        {
          field_name: "contact_email",
          value: email,
        },
        {
          field_name: "contact_no",
          value: number,
        },
      ];
      const id = formData.id;

      updateData.forEach(async (data) => {
        const result = await updateCustomerContactTableData({ token: token, data: { ...data, id } }).unwrap();
        if (result) {
          setIsEditing(false);
          {
            result?.data?.original
              ? dispatch(pushAlert({ visible: true, message: result?.data?.original?.error, type: "danger" }))
              : dispatch(pushAlert({ visible: true, message: result?.message, type: "success" }));
          }
        }
      });
    } catch (error) {
      dispatch(pushAlert({ visible: true, message: "Error updating data!", type: "danger" }));
    }
  };

  const handleDeleteContact = async (data) => {
    const payload = {
      recordType: "contact",
      rid: data?.id,
      cid: addCustomerId ? addCustomerId : Number(customerId),
    };
    handleDelete(payload, data?.name);
  };

  function convertContactsData(data) {
    return data.map((item) => {
      return {
        id: item.id,
        name: item.name,
        contact_email: item.contact_email,
        contact_no: item.contact_no,
      };
    });
  }

  useEffect(() => {
    if (true) {
      setCustomer(convertContactsData(customerContactPersonData || []));
    }
  }, [customerContactPersonData]);

  return (
    <div className="relative bg-white h-full w-full font-popns flex flex-col space-y-3 ">
      {/* <h3 className="text-16 font-500 text-434852 pt-2 px-3 my-2">
        {isAddMode ? "Add Contact Person" : isEditMode ? "Edit Contact Person" : ""}
      </h3> */}
      {isEditMode ? (
        <>
          <form onSubmit={handleSave} className="grow min-h-0 flex flex-col justify-between gap-5 pt-3 pb-5 mt-3">
            <div className="space-y-3 px-3">
              <div className="">
                <label htmlFor="Designation" className="block text-14 font-400 text-434852">
                  Name <span className="mb-1 text-red-500"> * </span>
                  {errors.name && <span className="text-red-500">{errors.name}</span>}
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  placeholder="Enter Name"
                  value={formData.name}
                  onChange={handleFieldChange}
                  onBlur={handleBlur}
                  className="bg-white border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-12 text-434852 font-400 block w-full rounded-[5px]"
                />
              </div>

              <div className=" ">
                <label htmlFor="contact_email" className="block text-14 font-400 text-434852">
                  Email <span className=" text-red-500"> * </span>
                  {errors.contact_email && <span className="text-red-500">{errors?.contact_email}</span>}
                </label>
                <input
                  type="text"
                  id="contact_email"
                  name="contact_email"
                  placeholder="Enter Email"
                  value={formData.contact_email}
                  onChange={handleFieldChange}
                  onBlur={handleBlur}
                  className=" rounded-[5px] bg-white  border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5 text-12 text-434852 font-400 block w-full"
                />
              </div>
              <div className="">
                <label htmlFor="contact_no" className="block text-14 font-400 text-434852">
                  Contact No <span className=" text-red-500"> * </span>
                  {errors.contact_no && <span className="text-red-500">{errors.contact_no}</span>}
                </label>
                <input
                  type="text"
                  id="contact_no"
                  name="contact_no"
                  placeholder="Enter Number"
                  value={formData.contact_no}
                  onChange={handleFieldChange}
                  onBlur={handleBlur}
                  maxLength="16"
                  className=" rounded-[5px] bg-white  border border-DFE2E5 focus:outline-hidden focus:ring-0 focus:border-1D5D9B  active:border active:border-DFE2E5  text-12 text-434852 font-400 block w-full  p-3"
                />
              </div>
            </div>

            <div className="flex justify-end text-md w-full border-t border-BECBD3 pt-3 px-3">
              <button
                onClick={handleCancel}
                type="button"
                className="px-6 py-1 text-16  rounded-5px font-500 bg-F4F4F4 focus:outline-none me-2"
              >
                CANCEL
              </button>
              <button
                type="submit"
                className="px-6 py-1 text-16 rounded-5px font-500 bg-1D4469 text-white focus:outline-none cbtn-transition-bg cbtn-transition-bg "
              >
                SAVE
              </button>
            </div>
          </form>
        </>
      ) : (
        <div
          className={`grow min-h-0 pb-10 overflow-y-auto  thinscrollbar pr-2 ${customer.length > 0 ? "" : "items-center"}`}
        >
          {customer?.length ? (
            customer.map((data, index) => {
              return (
                <>
                  <div className="border-b  rounded-md group">
                    <div
                      className="relative transition-all duration-300"
                      onMouseEnter={() => setHoveredIndex(data.id)}
                      onMouseLeave={() => setHoveredIndex(null)}
                    >
                      <div className={`py-2 ${hoveredIndex === data.id ? "bg-[#F1F6F9]" : "bg-white"} px-3 group`}>
                        <div className="flex flex-col gap-3">
                          <div className="flex items-center gap-1.5">
                            <span className="">
                              <Profile />
                            </span>
                            <span className="text-2C495D font-400 text-sm">{data.name ? data.name : "--"} </span>
                          </div>
                          <div className="flex gap-1.5 items-center group/copy ">
                            <span className="">
                              <GmailIcon />
                            </span>
                            <span className="text-2C495D font-400 text-sm">
                              {data.contact_email ? data?.contact_email : "--"}
                            </span>
                            <div className="invisible group-hover/copy:visible ml-2">
                              <CopyIconComponent copyValue={data?.contact_email} />
                            </div>
                          </div>
                          <div className="flex gap-1.5 items-center group/copy">
                            <span className="">
                              <Call />
                            </span>
                            <span className="text-2C495D font-400 text-sm">
                              {data?.contact_no ? data?.contact_no : "--"}
                            </span>
                            <div className="invisible group-hover/copy:visible ml-2">
                              <CopyIconComponent copyValue={data?.contact_no} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="absolute right-1 bottom-1 group/editDelete ">
                        <div
                          className={`flex justify-end me-4 gap-4 transition-opacity items-center opacity-0 group-hover:opacity-100 `}
                        >
                          <button onClick={() => handleEdit(data.id, data)}>
                            <i className="bi bi-pencil-fill text-[#969BA9] font-500"></i>
                          </button>
                          <button onClick={() => handleDeleteContact(data)}>
                            <i className="bi bi-trash-fill text-[#F84545] font-500"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })
          ) : (
            <>
              <EmptyMessage Icon={personContact} Message={"No Contact is available."} ButtonText={"Add Contact"} />
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default CustomerContactPersonModel;
